import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-flexbox-grid';
// import {Spacer} from 'layout/util'
import DisplayLocation from './DisplayLocation'

const Title = styled.h1`
	text-align: center;
	margin-bottom: 0;
`;

const Subheadline = styled.p`
	text-align: center;
	font-size: 14px;
	line-height: 20px;
`;

const UpdateTime = styled.h3`
	text-align: center;
`;

const LocationDisclaimer = styled.h2`
	position: absolute;
	font-size: 12px;
	text-align: right;
	font-weight: 400;
	line-height: 18px;
	right: 60px;
	top: 80px;
	color: #666;
	@media screen and (max-width: 767px) {
		font-size: 12px;
		text-align: center;
		position: static;
		display: block;
	}
`;
class IntroSection extends React.Component {
	render() {
		const {title, subtitle, lastUpdated, showLocationChange} = this.props;
		return(
			<Row>
		    <Col
		    	xsOffset={1} xs={10}

		      smOffset={2} sm={8}
		      mdOffset={2} md={8}
		      lgOffset={2} lg={8}
	      >
	      	<Title>{title}</Title>
	      </Col>
		    <Col
		    	xsOffset={1} xs={10}
		      smOffset={2} sm={8}
		      mdOffset={3} md={6}
		      lgOffset={3} lg={6}
	      >
	      	<Subheadline>{subtitle}</Subheadline>
	      	{ lastUpdated &&
		      	<UpdateTime>Last updated: {lastUpdated}</UpdateTime>
	      	}
	      </Col>
				<Col
					xsOffset={1} xs={10}
					smOffset={2} sm={8}
					mdOffset={0} md={3}
					lgOffset={0} lg={3}
				>
					{showLocationChange &&
						<LocationDisclaimer>
							<DisplayLocation/>
						</LocationDisclaimer>
					}
				</Col>

			</Row>
		)
	}
}
export default IntroSection;



// WEBPACK FOOTER //
// ./src/pages/june-5/components/intro-section.js